import React from 'react';

const CheckboxField = ({ id, label, labelLeft, fontWeight, checked, onChange, name, value, explanation, register, rules, error, disabled }) => {
  
  const reg = register ? {...register(name, rules)} : {
    onChange,
    name,
    checked
  };
  const checkId = id || name; 

  return (
    <div className="mb-3">
      <div className="flex flex-col">
        <div className="flex items-center mb-2">
        {rules?.required && <span className="font-bold text-red mr-2">*</span>}
          {label && (
            <label className={`flex items-center pr-6 mb-1 text-sm ${fontWeight == 'normal' ? 'font-normal' : 'font-bold text-brandMidBlue'}`}>
              <input
                type="checkbox"
                 id={checkId}
                {...reg}
                value={value}
                className="block mr-2"
                checked={checked}
                onChange={onChange}
                disabled={disabled}
              />
              {label}
            </label>
          )}
        </div>
        {explanation && (
          <span className="text-brandDarkBlue text-xs text-gray-500 my-1">{explanation}</span>
        )}
        {error && <span className='text-red text-xs'>{error}</span>}
      </div>
    </div>
  );
};

export default CheckboxField;